<template>
  <div class="new-drawer-form">
    <div v-show="searchType == '人选'" class="drawer-tips">
      <!-- 人选关键词搜索的几种格式： <br />1.姓名 2.姓名+空格+公司 3.姓名+|+职能模块 <br />4.手机号
      5.姓名+空格+公司+空格+部门 <br />6.姓名+|+公司+|+职能模块 -->
      <br /><strong>请输入关键词，多个关键词之间请用空格空开</strong> <br /><strong
        >可以使用拼音搜索，每个字用空格分开</strong
      >
      <br /><br />
    </div>
    <div style="display:flex">
      <i class="el-icon-arrow-left drawer-search-icon" @click="goBack"></i>
      <el-autocomplete
        v-if="searchType != '行业薪酬'"
        v-model="keywords"
        :placeholder="placeholder"
        class="input-with-select"
        size="mini"
        :fetch-suggestions="querySearch"
        @focus="showHistory"
        @keypress.native="
          e => {
            e.keyCode === 13 && doSearch()
          }
        "
      >
        <el-select slot="prepend" v-model="searchType" class="drawer-select" size="mini" @change="changeSearchType">
          <el-option label="人选" value="人选"></el-option>
          <el-option label="公司" value="公司"></el-option>
          <el-option label="项目" value="项目"></el-option>
          <el-option label="资源库" value="文件"></el-option>
          <el-option label="薪酬" value="薪酬"></el-option>
          <el-option label="行业薪酬" value="行业薪酬"></el-option>
        </el-select>
        <el-button slot="append" icon="el-icon-search" size="mini" @click="doSearch"></el-button>
      </el-autocomplete>
      <el-select v-else v-model="searchType" class="drawer-select" size="mini" @change="changeSearchType">
        <el-option label="人选" value="人选"></el-option>
        <el-option label="公司" value="公司"></el-option>
        <el-option label="项目" value="项目"></el-option>
        <el-option label="资源库" value="文件"></el-option>
        <el-option label="薪酬" value="薪酬"></el-option>
        <el-option label="行业薪酬" value="行业薪酬"></el-option>
      </el-select>
    </div>
    <SearchHistory
      :is-history-show="isHistoryShow"
      :search-type="searchType"
      @setKeywords="setKeywords"
    ></SearchHistory>
  </div>
</template>
<script>
import SearchHistory from '../commonComponents/searchHistory'

import { searchLabel2Value, searchPlaceHolder } from '../constant/utils'

export default {
  components: { SearchHistory },
  props: {
    showHistoryDialog: { type: Boolean, default: false },
    searchLabel: { type: String, default: '' },
  },
  data: function() {
    return {
      placeholder: '请输入内容',
      searchType: '人选',
      keywords: '',
      isHistoryShow: false,
    }
  },
  watch: {
    showHistoryDialog(newValue, oldValue) {
      this.isHistoryShow = newValue
    },
    searchLabel: {
      handler(newValue, oldValue) {
        this.placeholder = searchPlaceHolder[newValue] || '请输入内容'
        this.searchType = searchLabel2Value[newValue] || newValue
      },
      immediate: true,
    },
  },
  methods: {
    goBack() {
      this.$emit('goBack')
    },
    showHistory() {
      this.isHistoryShow = true
      this.$emit('showHistory')
    },
    setKeywords(kw) {
      this.keywords = kw
      this.doSearch()
    },
    async querySearch(queryString, cb) {
      if (this.searchType !== '薪酬' || !queryString) return cb([])
      const res = await app.service('company').serchCompany(this.keywords)
      this.restaurants = []
      if (res.status === 200) {
        const restaurants = res.data.map(val => ({ value: val.简称 }))
        this.restaurants = restaurants
        const results = queryString ? restaurants.filter(val => val.value.includes(queryString)) : restaurants
        cb(results)
      } else cb([])
    },
    checkSelect() {
      const { searchType, keywords, restaurants = [] } = this
      if (searchType !== '薪酬') return
      const company = restaurants.find(v => v.value === keywords)
      if (company) this.$emit('salaryChooseCompany', company.value)
    },
    async doSearch() {
      this.checkSelect()
      this.$emit('doSearch', { type: this.searchType, keywords: this.keywords })
      this.isHistoryShow = false
    },
    changeSearchType() {
      this.$emit('changeSearchType', this.searchType)
    },
  },
}
</script>
<style scoped>
.input-with-select {
  width: 100%;
}
.drawer-search-icon {
  font-size: 16px;
  line-height: 28px;
  margin-right: 10px;
  cursor: pointer;
  z-index: 1001;
  position: relative;
}
</style>
